import { Page } from './Page';

// Placeholder for sections that are not yet built (Daily, Roster, Holidays,
// Timesheet, Finances, Messages). Renders the nav label as the page title and
// the "on the way" notice — identical to the former ComingSoon block (AC4,
// edge case: an unbuilt key renders the placeholder with its label).
export function ComingSoonPage({ label }: { label: string }) {
  return (
    <Page title={label}>
      <div className="bookings-empty">
        <div className="be-inner">
          <p>{label} is on the way — not built yet.</p>
        </div>
      </div>
    </Page>
  );
}
